import { render, staticRenderFns } from "./PointSetting.vue?vue&type=template&id=13a5bb5e&scoped=true"
import script from "./PointSetting.vue?vue&type=script&lang=js"
export * from "./PointSetting.vue?vue&type=script&lang=js"
import style0 from "./PointSetting.vue?vue&type=style&index=0&id=13a5bb5e&prod&lang=scss"
import style1 from "./PointSetting.vue?vue&type=style&index=1&id=13a5bb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5bb5e",
  null
  
)

export default component.exports